export const variants = {
	personas: {
		body: ["checkered", "rounded", "small", "squared"],
		eyes: ["happy", "open", "wink"],
		facialHair: [
			"none",
			"beardMustache",
			"goatee",
			"pyramid",
			"shadow",
			"soulPatch",
			"walrus",
		],
		hair: [
			"bald",
			"balding",
			"beanie",
			"bobBangs",
			"bobCut",
			"bunUndercut",
			"buzzcut",
			"cap",
			"curly",
			"curlyBun",
			"curlyHighTop",
			"extraLong",
			"fade",
			"long",
			"mohawk",
			"pigtails",
			"shortCombover",
			"shortComboverChops",
			"sideShave",
			"straightBun",
		],
		mouth: [
			"bigSmile",
			"frown",
			"lips",
			"pacifier",
			"smile",
			"smirk",
			"surprise",
		],
		nose: ["mediumRound", "smallRound", "wrinkles"],
	},
	pixelArt: {
		clothing: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
			"variant09",
			"variant10",
			"variant11",
			"variant12",
			"variant13",
			"variant14",
			"variant15",
			"variant16",
			"variant17",
			"variant18",
			"variant19",
			"variant20",
			"variant21",
			"variant22",
			"variant23",
		],
		hair: [
			"long01",
			"long02",
			"long03",
			"long04",
			"long05",
			"long06",
			"long07",
			"long08",
			"long09",
			"long10",
			"long11",
			"long12",
			"long13",
			"long14",
			"long15",
			"long16",
			"long17",
			"long18",
			"long19",
			"long20",
			"long21",
			"short01",
			"short02",
			"short03",
			"short04",
			"short05",
			"short06",
			"short07",
			"short08",
			"short09",
			"short10",
			"short11",
			"short12",
			"short13",
			"short14",
			"short15",
			"short16",
			"short17",
			"short18",
			"short19",
			"short20",
			"short21",
			"short22",
			"short23",
			"short24",
		],
		mouth: [
			"happy01",
			"happy02",
			"happy03",
			"happy04",
			"happy05",
			"happy06",
			"happy07",
			"happy08",
			"happy09",
			"happy10",
			"happy11",
			"happy12",
			"happy13",
			"sad01",
			"sad02",
			"sad03",
			"sad04",
			"sad05",
			"sad06",
			"sad07",
			"sad08",
			"sad09",
			"sad10",
		],
		beard: [
			"none",
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
		],
		eyes: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
			"variant09",
			"variant10",
			"variant11",
			"variant12",
		],
	},
	avataaars: {
		top: [
			"none",
			"bigHair",
			"bob",
			"bun",
			"curly",
			"curvy",
			"dreads",
			"frida",
			"fro",
			"froBand",
			"hat",
			"hijab",
			"longButNotTooLong",
			"miaWallace",
			"shaggy",
			"shaggyMullet",
			"shavedSides",
			"shortCurly",
			"shortDreads",
			"shortFlat",
			"shortRound",
			"shortWaved",
			"sides",
			"straight01",
			"straight02",
			"straightAndStrand",
			"turban",
			"winterHat01",
			"winterHat02",
			"winterHat03",
			"winterHat04",
		],
		eyes: [
			"close",
			"cry",
			"default",
			"dizzy",
			"eyeRoll",
			"happy",
			"hearts",
			"side",
			"squint",
			"surprised",
			"wink",
			"winkWacky",
		],
		mouth: [
			"concerned",
			"default",
			"disbelief",
			"eating",
			"grimace",
			"sad",
			"screamOpen",
			"serious",
			"smile",
			"tongue",
			"twinkle",
			"vomit",
		],
		eyebrows: [
			"angry",
			"angryNatural",
			"default",
			"defaultNatural",
			"flatNatural",
			"frownNatural",
			"raisedExcited",
			"raisedExcitedNatural",
			"sadConcerned",
			"sadConcernedNatural",
			"unibrowNatural",
			"upDown",
			"upDownNatural",
		],
		facialHair: [
			"none",
			"beardMedium",
			"beardLight",
			"beardMajestic",
			"moustacheFancy",
			"moustacheMagnum",
		],
		clothing: [
			"blazerShirt",
			"blazerSweater",
			"collarSweater",
			"graphicShirt",
			"hoodie",
			"overall",
			"shirtCrewNeck",
			"shirtScoopNeck",
			"shirtVNeck",
		],
		accessories: [
			"none",
			"eyepatch",
			"kurt",
			"prescription01",
			"prescription02",
			"round",
			"sunglasses",
			"wayfarers",
		],
	},
	lorelei: {
		beard: ["none", "variant01", "variant02"],
		eyebrows: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
			"variant09",
			"variant10",
			"variant11",
			"variant12",
			"variant13",
		],
		eyes: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
			"variant09",
			"variant10",
			"variant11",
			"variant12",
			"variant13",
			"variant14",
			"variant15",
			"variant16",
			"variant17",
			"variant18",
			"variant19",
			"variant20",
			"variant21",
			"variant22",
			"variant23",
			"variant24",
		],
		freckles: ["none", "variant01"],
		hair: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
			"variant07",
			"variant08",
			"variant09",
			"variant10",
			"variant11",
			"variant12",
			"variant13",
			"variant14",
			"variant15",
			"variant16",
			"variant17",
			"variant18",
			"variant19",
			"variant20",
			"variant21",
			"variant22",
			"variant23",
			"variant24",
			"variant25",
			"variant26",
			"variant27",
			"variant28",
			"variant29",
			"variant30",
			"variant31",
			"variant32",
			"variant33",
			"variant34",
			"variant35",
			"variant36",
			"variant37",
			"variant38",
			"variant39",
			"variant40",
			"variant41",
			"variant42",
			"variant43",
			"variant44",
			"variant45",
			"variant46",
			"variant47",
			"variant48",
		],
		head: ["variant04", "variant03", "variant02", "variant01"],
		mouth: [
			"happy01",
			"happy02",
			"happy03",
			"happy04",
			"happy05",
			"happy06",
			"happy07",
			"happy08",
			"happy09",
			"happy10",
			"happy11",
			"happy12",
			"happy13",
			"happy14",
			"happy15",
			"happy16",
			"happy17",
			"happy18",
			"sad01",
			"sad02",
			"sad03",
			"sad04",
			"sad05",
			"sad06",
			"sad07",
			"sad08",
			"sad09",
		],
		nose: [
			"variant01",
			"variant02",
			"variant03",
			"variant04",
			"variant05",
			"variant06",
		],
	},
};

export const variantLabels = {
	personas: {
		body: {
			checkered: "Checkered",
			rounded: "Rounded",
			small: "Small",
			squared: "Squared",
		},
		eyes: {
			happy: "Happy",
			open: "Open",
			wink: "Wink",
		},
		facialHair: {
			none: "None",
			beardMustache: "Bearded",
			goatee: "Goatee",
			pyramid: "Pyramid",
			shadow: "Shadow",
			soulPatch: "Soulpatch",
			walrus: "Walrus",
		},
		hair: {
			bald: "Bald",
			balding: "Balding",
			beanie: "Beanie",
			bobBangs: "Bobbed",
			bobCut: "Cropped",
			bunUndercut: "Bunned",
			buzzcut: "Buzzcut",
			cap: "Capped",
			curly: "Curly",
			curlyBun: "Bundled",
			curlyHighTop: "Hightop",
			extraLong: "Flowing",
			fade: "Fade",
			long: "Long",
			mohawk: "Mohawk",
			pigtails: "Pigtails",
			shortCombover: "Combover",
			shortComboverChops: "Chopped",
			sideShave: "Shaved",
			straightBun: "Bunned",
		},
		mouth: {
			bigSmile: "Grinning",
			frown: "Frown",
			lips: "Lips",
			pacifier: "Pacifier",
			smile: "Smile",
			smirk: "Smirk",
			surprise: "Surprise",
		},
		nose: {
			mediumRound: "Medium",
			smallRound: "Small",
			wrinkles: "Wrinkles",
		},
	},
	pixelArt: {
		clothing: {
			variant01: "Classic",
			variant02: "Casual",
			variant03: "Tank",
			variant04: "Hoodie",
			variant05: "Polo",
			variant06: "Vneck",
			variant07: "Buttoned",
			variant08: "Sweater",
			variant09: "Jersey",
			variant10: "Jacket",
			variant11: "Vest",
			variant12: "Blazer",
			variant13: "Cardigan",
			variant14: "Windbreaker",
			variant15: "Denim",
			variant16: "Leather",
			variant17: "Bomber",
			variant18: "Track",
			variant19: "Puffer",
			variant20: "Sports",
			variant21: "Flannel",
			variant22: "Hawaiian",
			variant23: "Turtleneck",
		},
		hair: {
			long01: "Flowing",
			long02: "Wavy",
			long03: "Straight",
			long04: "Curly",
			long05: "Braided",
			long06: "Ponytail",
			long07: "Sidepart",
			long08: "Centerpart",
			long09: "Layered",
			long10: "Beachy",
			long11: "Sleek",
			long12: "Messy",
			long13: "Windswept",
			long14: "Voluminous",
			long15: "Pinstraight",
			long16: "Curled",
			long17: "Halfup",
			long18: "Highpony",
			long19: "Lowpony",
			long20: "Sideswept",
			long21: "Boho",
			short01: "Pixie",
			short02: "Bobbed",
			short03: "Crew",
			short04: "Buzzed",
			short05: "Undercut",
			short06: "Faded",
			short07: "Quiff",
			short08: "Pompadour",
			short09: "Slicked",
			short10: "Tousled",
			short11: "Spiky",
			short12: "Textured",
			short13: "French",
			short14: "Caesar",
			short15: "Ivy",
			short16: "Parted",
			short17: "Combed",
			short18: "Fauxhawk",
			short19: "Mohawk",
			short20: "Shaggy",
			short21: "Kinky",
			short22: "Waved",
			short23: "Ruffled",
			short24: "Clean",
		},
		mouth: {
			happy01: "Grinning",
			happy02: "Grin",
			happy03: "Cheerful",
			happy04: "Smirk",
			happy05: "Friendly",
			happy06: "Toothy",
			happy07: "Slight",
			happy08: "Warm",
			happy09: "Bright",
			happy10: "Joyful",
			happy11: "Content",
			happy12: "Pleased",
			happy13: "Beaming",
			sad01: "Frown",
			sad02: "Pout",
			sad03: "Disappointed",
			sad04: "Concerned",
			sad05: "Worried",
			sad06: "Upset",
			sad07: "Down",
			sad08: "Glum",
			sad09: "Melancholy",
			sad10: "Somber",
		},
		beard: {
			none: "Clean",
			variant01: "Full",
			variant02: "Goatee",
			variant03: "Stubble",
			variant04: "Vandyke",
			variant05: "Chinstrap",
			variant06: "Muttonchops",
			variant07: "Soulpatch",
			variant08: "Circle",
		},
		eyes: {
			variant01: "Wide",
			variant02: "Friendly",
			variant03: "Focused",
			variant04: "Gentle",
			variant05: "Bright",
			variant06: "Alert",
			variant07: "Calm",
			variant08: "Curious",
			variant09: "Determined",
			variant10: "Relaxed",
			variant11: "Confident",
			variant12: "Thoughtful",
		},
	},
	avataaars: {
		top: {
			none: "Bald",
			bigHair: "Bighair",
			bob: "Bob",
			bun: "Bun",
			curly: "Curly",
			curvy: "Curvy",
			dreads: "Dreads",
			frida: "Frida",
			fro: "Fro",
			froBand: "Froband",
			hat: "Hat",
			hijab: "Hijab",
			longButNotTooLong: "Long",
			miaWallace: "Mia",
			shaggy: "Shaggy",
			shaggyMullet: "Mullet",
			shavedSides: "Shaved",
			shortCurly: "Shortcurly",
			shortDreads: "Shortdreads",
			shortFlat: "Shortflat",
			shortRound: "Shortround",
			shortWaved: "Shortwaved",
			sides: "Sides",
			straight01: "Straight",
			straight02: "Sleek",
			straightAndStrand: "Stranded",
			turban: "Turban",
			winterHat01: "Beanie",
			winterHat02: "Knit",
			winterHat03: "Pom",
			winterHat04: "Winter",
		},
		eyes: {
			close: "Close",
			cry: "Cry",
			default: "Default",
			dizzy: "Dizzy",
			eyeRoll: "Eyeroll",
			happy: "Happy",
			hearts: "Hearts",
			side: "Side",
			squint: "Squint",
			surprised: "Surprised",
			wink: "Wink",
			winkWacky: "Wacky",
		},
		mouth: {
			concerned: "Concerned",
			default: "Default",
			disbelief: "Disbelief",
			eating: "Eating",
			grimace: "Grimace",
			sad: "Sad",
			screamOpen: "Scream",
			serious: "Serious",
			smile: "Smile",
			tongue: "Tongue",
			twinkle: "Twinkle",
			vomit: "Vomit",
		},
		eyebrows: {
			angry: "Angry",
			angryNatural: "Furrowed",
			default: "Default",
			defaultNatural: "Natural",
			flatNatural: "Flat",
			frownNatural: "Frown",
			raisedExcited: "Raised",
			raisedExcitedNatural: "Excited",
			sadConcerned: "Sad",
			sadConcernedNatural: "Concerned",
			unibrowNatural: "Unibrow",
			upDown: "Updown",
			upDownNatural: "Asymmetric",
		},
		facialHair: {
			none: "None",
			beardMedium: "Medium",
			beardLight: "Light",
			beardMajestic: "Majestic",
			moustacheFancy: "Fancy",
			moustacheMagnum: "Magnum",
		},
		clothing: {
			blazerShirt: "Blazer",
			blazerSweater: "Formal",
			collarSweater: "Collar",
			graphicShirt: "Graphic",
			hoodie: "Hoodie",
			overall: "Overall",
			shirtCrewNeck: "Crewneck",
			shirtScoopNeck: "Scoop",
			shirtVNeck: "Vneck",
		},
		accessories: {
			none: "None",
			eyepatch: "Eyepatch",
			kurt: "Kurt",
			prescription01: "Glasses",
			prescription02: "Reading",
			round: "Round",
			sunglasses: "Sunglasses",
			wayfarers: "Wayfarers",
		},
	},
	lorelei: {
		beard: {
			none: "Clean",
			variant01: "Full",
			variant02: "Goatee",
		},
		eyebrows: {
			variant01: "Natural",
			variant02: "Arched",
			variant03: "Straight",
			variant04: "Thick",
			variant05: "Thin",
			variant06: "Angular",
			variant07: "Rounded",
			variant08: "Bushy",
			variant09: "Feathered",
			variant10: "Defined",
			variant11: "Soft",
			variant12: "Bold",
			variant13: "Subtle",
		},
		eyes: {
			variant01: "Wide",
			variant02: "Almond",
			variant03: "Round",
			variant04: "Narrow",
			variant05: "Bright",
			variant06: "Gentle",
			variant07: "Intense",
			variant08: "Sleepy",
			variant09: "Alert",
			variant10: "Curious",
			variant11: "Focused",
			variant12: "Dreamy",
			variant13: "Sparkling",
			variant14: "Serious",
			variant15: "Playful",
			variant16: "Mysterious",
			variant17: "Friendly",
			variant18: "Confident",
			variant19: "Shy",
			variant20: "Bold",
			variant21: "Soft",
			variant22: "Sharp",
			variant23: "Warm",
			variant24: "Cool",
		},
		freckles: {
			none: "None",
			variant01: "Freckles",
		},
		hair: {
			variant01: "Pixie",
			variant02: "Bob",
			variant03: "Lob",
			variant04: "Shoulder",
			variant05: "Straight",
			variant06: "Wavy",
			variant07: "Curly",
			variant08: "Ponytail",
			variant09: "Highbun",
			variant10: "Lowbun",
			variant11: "Messybun",
			variant12: "Braids",
			variant13: "Sidebraid",
			variant14: "French",
			variant15: "Fishtail",
			variant16: "Spacebuns",
			variant17: "Halfup",
			variant18: "Topknot",
			variant19: "Shag",
			variant20: "Layers",
			variant21: "Bangs",
			variant22: "Sideswept",
			variant23: "Centerpart",
			variant24: "Sidepart",
			variant25: "Slicked",
			variant26: "Voluminous",
			variant27: "Sleek",
			variant28: "Textured",
			variant29: "Choppy",
			variant30: "Feathered",
			variant31: "Flipped",
			variant32: "Pincurls",
			variant33: "Fingerwaves",
			variant34: "Victory",
			variant35: "Beehive",
			variant36: "Bouffant",
			variant37: "Afro",
			variant38: "Cornrows",
			variant39: "Dreadlocks",
			variant40: "Twists",
			variant41: "Buzzed",
			variant42: "Undercut",
			variant43: "Mohawk",
			variant44: "Fauxhawk",
			variant45: "Quiff",
			variant46: "Pompadour",
			variant47: "Crew",
			variant48: "Caesar",
		},
		head: {
			variant01: "Round",
			variant02: "Oval",
			variant03: "Square",
			variant04: "Heart",
		},
		mouth: {
			happy01: "Grinning",
			happy02: "Grin",
			happy03: "Cheerful",
			happy04: "Smirk",
			happy05: "Friendly",
			happy06: "Toothy",
			happy07: "Slight",
			happy08: "Warm",
			happy09: "Bright",
			happy10: "Joyful",
			happy11: "Content",
			happy12: "Pleased",
			happy13: "Beaming",
			happy14: "Laughing",
			happy15: "Giggling",
			happy16: "Amused",
			happy17: "Delighted",
			happy18: "Ecstatic",
			sad01: "Frown",
			sad02: "Pout",
			sad03: "Disappointed",
			sad04: "Concerned",
			sad05: "Worried",
			sad06: "Upset",
			sad07: "Down",
			sad08: "Glum",
			sad09: "Melancholy",
		},
		nose: {
			variant01: "Button",
			variant02: "Straight",
			variant03: "Rounded",
			variant04: "Pointed",
			variant05: "Wide",
			variant06: "Narrow",
		},
	},
};

export const defaultSettings = {
	pixelArt: {
		size: 128,
		seed: "Aneka",
		beardProbability: 100,
		beard: ["none"],
		glassesProbability: 100,
		glasses: ["none"],
		accessories: ["none"],
		clothing: ["variant05"],
		clothingColor: ["ff6f69"],
		eyes: ["variant06"],
		hair: ["long01"],
		hairColor: ["4F2E1A"],
		mouth: ["happy02"],
		skinColor: ["E8C69B"],
		backgroundColor: ["65C9FF"],
	},
	personas: {
		size: 128,
		seed: "Aneka",
		facialHairProbability: 100,
		facialHair: ["none"],
		body: ["squared"],
		eyes: ["happy"],
		hair: ["bunUndercut"],
		mouth: ["smirk"],
		nose: ["smallRound"],
		skinColor: ["D0B08A"],
		hairColor: ["4F2E1A"],
		backgroundColor: ["ADC8DC"],
	},
	avataaars: {
		size: 128,
		seed: "Aneka",
		accessories: ["round"],
		accessoriesColor: ["8231D8"],
		accessoriesProbability: 100,
		clothing: ["hoodie"],
		clothesColor: ["A609FB"],
		eyebrows: ["frownNatural"],
		eyes: ["eyeRoll"],
		facialHair: ["none"],
		facialHairProbability: 100,
		facialHairColor: ["D42B99"],
		mouth: ["eating"],
		top: ["longButNotTooLong"],
		hairColor: ["D42B99"],
		hatColor: ["A609FB"],
		skinColor: ["826851"],
		backgroundColor: ["F692E9"],
	},
	lorelei: {
		size: 128,
		seed: "Aneka",
		beardProbability: 100,
		frecklesProbability: 100,
		beard: ["none"],
		eyebrows: ["variant01"],
		freckles: ["none"],
		accessories: ["none"],
		eyes: ["variant01"],
		hair: ["variant35"],
		head: ["variant04"],
		mouth: ["happy01"],
		nose: ["variant01"],
		skinColor: ["C9AA85"],
		hairColor: ["4F2E1A"],
		backgroundColor: ["E8F4F8"],
	},
};
